import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import { LinkTabNavHorizontal } from '../../components';

import css from './UserNav.module.css';
import { hasGroups, isApprovedSeller, isApprovedOwner } from '../../util/userHelpers';

const UserNav = props => {
  const { className, rootClassName, currentPage, currentUser, currentHash } = props;
  const classes = classNames(rootClassName || css.root, className);

  let isOwner = isApprovedOwner(currentUser);
  let isApproved = isApprovedSeller(currentUser);
  let userHasGroups = hasGroups(currentUser);

  let { sellerType = 'manufacturer' } = currentUser?.attributes?.profile?.publicData || {};

  let isManufacturer = sellerType == 'manufacturer';
  const isSeller = !!sellerType || isApproved || isOwner;
  const onStoreMediaSection =
    currentPage === 'ProfileSettingsPage' && currentHash === '#store-media';
  const isLightspeedAuthorized =
    currentUser?.attributes?.profile?.privateData?.lightspeedConfig?.authorized === true;

  const tabs = [
    ...(isApproved
      ? [
          {
            text: <FormattedMessage id="UserNav.yourListings" />,
            selected: currentPage === 'ManageListingsPage',
            linkProps: {
              name: 'ManageListingsPage',
            },
          },
        ]
      : []),
    ...(isApproved && isLightspeedAuthorized
      ? [
          {
            text: (
              <FormattedMessage id="UserNav.lightspeedIntegration" defaultMessage="Lightspeed" />
            ),
            selected: currentPage === 'LightspeedIntegrationPage',
            disabled: false,
            linkProps: { name: 'LightspeedIntegrationPage' },
          },
        ]
      : []),
    {
      text: <FormattedMessage id="UserNav.profileSettings" />,
      selected: currentPage === 'ProfileSettingsPage' && !onStoreMediaSection,
      disabled: false,
      linkProps: {
        name: 'ProfileSettingsPage',
      },
    },
    ...(isSeller
      ? [
          {
            text: 'Store Media',
            selected: onStoreMediaSection,
            disabled: false,
            linkProps: {
              name: 'ProfileSettingsPage',
              to: { hash: '#store-media' },
            },
          },
        ]
      : []),
    ...(isApproved
      ? [
          {
            text: <FormattedMessage id="UserNav.statistics" />,
            selected: currentPage === 'SellerStatisticsPage',
            disabled: false,
            linkProps: {
              name: 'SellerStatisticsPage',
            },
          },
          {
            text: <FormattedMessage id="UserNav.websiteAdmin" />,
            selected: currentPage === 'SellerWebsiteAdminPage',
            disabled: false,
            linkProps: {
              name: 'SellerWebsiteAdminPage',
            },
          },
        ]
      : []),
    /* {
      text: <FormattedMessage id="UserNav.businessProfileSettings" />,
      selected: currentPage === 'BusinessProfileSettingsPage',
      disabled: false,
      linkProps: {
        name: 'BusinessProfileSettingsPage',
      },
    }, */
    ...(isOwner
      ? [
          {
            text: <FormattedMessage id="UserNav.storeIntegration" />,
            selected: currentPage === 'StoreIntegrationPage',
            disabled: false,
            linkProps: {
              name: 'StoreIntegrationPage',
            },
          },
        ]
      : []),
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
    ...(userHasGroups
      ? [
          {
            text: <FormattedMessage id="UserNav.yourTeams" />,
            selected: currentPage === 'GroupsPage',
            linkProps: {
              name: 'GroupsPage',
            },
          },
        ]
      : []),
    ...(isOwner && !isManufacturer
      ? [
          {
            text: <FormattedMessage id="UserNav.teamInvites" />,
            selected: currentPage === 'InviteUsersPage',
            linkProps: {
              name: 'InviteUsersPage',
            },
          },
        ]
      : []),
  ];

  return (
    <LinkTabNavHorizontal className={classes} tabRootClassName={css.tab} tabs={tabs} skin="dark" />
  );
};

UserNav.defaultProps = {
  className: null,
  rootClassName: null,
  currentHash: '',
};

const { string } = PropTypes;

UserNav.propTypes = {
  className: string,
  rootClassName: string,
  currentPage: string.isRequired,
  currentHash: string,
};

export default UserNav;
